export default __webpack_public_path__ + "static/media/barcode.465c56e3.png";